import App from 'app/app.js';
import 'app/directive/LtSelectionTemplateFieldCtrl.js';

function LtSelectionTemplateFieldDirective() {
  return {
    restrict: 'E',
    require: ['ltSelectionTemplateField', '^form'],
    scope: {
      selectionTemplateField: '=',
      templateName: '=',
      model: '=',
      nameFieldValidation: '=',
      onFieldChanged: '&'
    },
    controller: 'LtSelectionTemplateFieldCtrl',
    controllerAs: 'ctrl',
    template:
      '<div ng-if="selectionTemplateField.type === ctrl.selectionFieldType.STRING" class="refreshed-field">' +
      '    <input type="text" name="fieldName" ng-model="ctrl.fieldData" lt-key-filter="name" data-test-trader-card-field' +
      '           maxlength="{{selectionTemplateField.length}}" ng-required="{{selectionTemplateField.isRequiredByLab}}" ng-change="ctrl.onFieldChanged()"/>' +
      '    <label>{{selectionTemplateField | ltSelectionTemplateFieldTranslateFilter: templateName : ctrl.LABEL}}</label>' +
      '</div>' +
      '<div ng-if="selectionTemplateField.type === ctrl.selectionFieldType.STRING && ctrl.isFieldDataInvalid()" class="text-left f6 text-alert" lt-translate="NAME_TEXT_PERSONALIZER_SPECIAL_CHAR_MSG"/>' +
      '<div ng-if="selectionTemplateField.type === ctrl.selectionFieldType.INT" class="refreshed-field">' +
      '    <input type="text" lt-key-filter="name" name="fieldName" ng-model="ctrl.fieldData"' +
      '           ng-required="{{selectionTemplateField.isRequiredByLab}}"' +
      '           lt-numeric-only lt-price lt-max="{{selectionTemplateField.max}}" lt-min="{{selectionTemplateField.min}}"' +
      '           placeholder="{{selectionTemplateField | ltSelectionTemplateFieldTranslateFilter: templateName : ctrl.EXAMPLE}}" ng-change="ctrl.onFieldChanged()"/>' +
      '    <label>{{selectionTemplateField | ltSelectionTemplateFieldTranslateFilter: templateName : ctrl.LABEL}}</label>' +
      '</div>' +
      '<div ng-if="selectionTemplateField.type === ctrl.selectionFieldType.CHOICES" class="refreshed-field">' +
      '    <select name="fieldName" ng-init="ctrl.fieldData = selectionTemplateField.choices[0].choice"' +
      '           ng-model="ctrl.fieldData" ng-required="{{selectionTemplateField.isRequiredByLab}}" ng-change="ctrl.onFieldChanged()" ' +
      '           ng-options="choices.choice as ( selectionTemplateField | ltSelectionTemplateFieldTranslateFilter: templateName : ctrl.CHOICES : choices) for choices in selectionTemplateField.choices">' +
      '    </select>' +
      '    <label>{{selectionTemplateField | ltSelectionTemplateFieldTranslateFilter: templateName : ctrl.LABEL}}</label>' +
      '</div>',
    link: function (scope, element, attrs, ctrl) {
      var directiveCtrl = ctrl[0],
        formCtrl = ctrl[1];

      directiveCtrl.setFieldData(scope.model.value);

      scope.model.getFieldData = function () {
        return directiveCtrl.getFieldData();
      };

      scope.model.getValidationData = function () {
        return directiveCtrl.getValidationData(formCtrl.fieldName);
      };

      scope.model.getLabelData = function () {
        return directiveCtrl.getTranslatedLabel();
      };

      scope.model.setFieldData = function (value) {
        directiveCtrl.setFieldData(value);
        formCtrl.fieldName.$setViewValue(value);
        formCtrl.fieldName.$render();
      };

      scope.model.isFieldDataInvalid = function () {
        return directiveCtrl.isFieldDataInvalid();
      };
    }
  };
}
App.directive('ltSelectionTemplateField', [LtSelectionTemplateFieldDirective]);
